import React from "react";

import { ZoneWithCells } from "../types";
import { Offset, Scale } from "./types";

type Props = Readonly<{
  height: number;
  offset: Offset;
  scale: Scale;
  setEditTable: (zone: ZoneWithCells) => void;
  tableZones: ReadonlyArray<ZoneWithCells>;
  width: number;
}>;

export const TableCellLinks = ({
  height,
  offset,
  scale,
  setEditTable,
  tableZones,
  width,
}: Props) => {
  if (tableZones.length < 1) {
    return null;
  }
  return (
    <div className="table-cell-links">
      {tableZones.map(z => (
        <a
          href="#"
          key={`${z.minX},${z.minY}`}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            setEditTable(z);
          }}
          style={{
            bottom: `${Math.ceil(height - (z.maxY * scale.y + offset.y))}px`,
            right: `${Math.ceil(width - (z.maxX * scale.x + offset.x))}px`,
          }}
        >
          Cells
        </a>
      ))}
    </div>
  );
};
